import axios from "axios";



export const xGridLicense = process.env.REACT_APP_XGRIDLICENSE

export const round =(num) =>{
    var m = Number((Math.abs(num) * 100).toPrecision(15));
    return Math.round(m) / 100 * Math.sign(num);

}

export const GetRecapchaSiteKey = (pathname) =>{
    if(pathname==='http://127.0.0.1'){
        return "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
    } else if(pathname==='https://www.namemysettlement.com'){
        return process.env.REACT_APP_RECAPTCHAKEY
    }
    
    else{
        return process.env.REACT_APP_RECAPTCHAKEY_STAGE
    }

}

export const axiosErrorHandling =({response}) => {
    let error_message = 'data: '+ response.data + ', status: ' + response.status + ', response.headers: ' + response.headers   

return error_message



}

export const setData = (data) =>{
    
    for(let i=0; i<data.length;i++){
            data[i].id=i+1     
        if (data[i].account_balance === null ){data[i].account_balance = data[i].principal}
        if (data[i].account_status === null){data[i].account_status = 'Ready to Settle'}
        if (data[i].promo_code_used === null){data[i].promo_code_used = [{}]} 
   
    }
    return data
}

export const getPDFData = async (customer_number) =>{
    const promise = await axios.post('api/oracle5/pdfinfo', {customer_number: customer_number})
    .then((result)=>{
        if (result.status===200){
            let pulledUserData = {first_name: result.data[0],
                                  last_name:  result.data[1],
                                  street_address_1: result.data[2],
                                  street_address_2: result.data[3],
                                  city: result.data[4],
                                  state: result.data[5],
                                  zip: result.data[6],
                                  zip4: result.data[7],
                                  }
            return pulledUserData
        
            }
        
        
         else {console.log('Other than 200 result')} 


    }).catch(errors=>{console.log("Here are the errors", errors)})

    return promise
}

export const getPartialFillData = (data, offerAccepted, newTotalDue, roundedTotalDue ) =>{
    let newData = []

    for(let i=0; i<data.length; i++){
        newData.push({
            settlement_amount:Number(round(offerAccepted*data[i].per_of_settlement)),
            original_creditor: data[i].original_creditor,
            original_account_number: data[i].original_account_number,
            batch_number: data[i].batch_number,
            balance: Number(round((roundedTotalDue - newTotalDue)*data[i].per_of_settlement)) 
        })
    }

    return newData

}

export const getAcceptedFillData = (data, offerAccepted) =>{
            
            
            let newData = []
            for(let i=0; i<data.length; i++){
                newData.push({
                    settlement_amount: round(offerAccepted*data[i].per_of_settlement),
                    original_creditor: data[i].original_creditor,
                    original_account_number: data[i].original_account_number,
                    batch_number: data[i].batch_number,
                    balance: round(offerAccepted*data[i].per_of_settlement)
                })

            }
            return newData
        }

    export const getPaidFillData = (data, offerAccepted ) =>{
        let newData = []

        for(let i=0; i<data.length; i++){
            newData.push({
                settlement_amount:(offerAccepted*data[i].per_of_settlement),
                original_creditor: data[i].original_creditor,
                original_account_number: data[i].original_account_number,
                batch_number: data[i].batch_number,
                balance: 0
            })
    }
    return newData

}

export const getUSAEPAYCCInfo = (baseURL) =>{
    let info ={}

    if (baseURL==='https://www.namemysettlement.com'){
        info = {
            url: process.env.REACT_APP_USAEPAY,
            key: process.env.REACT_APP_CCKEY
        }

        return info
    } else {
        info = {
            url: process.env.REACT_APP_USAEPAY_STAGE,
            key: process.env.REACT_APP_CCKEY_STAGE
        }

        return info

    }

}